export function processUrlForDemo(lookup: string): string {
  let newLookup = lookup;
  if (lookup.includes("parrot")) {
    newLookup = lookup.replace("parrot", "paschal");
  } else if (lookup.includes("parakeet")) {
    newLookup = lookup.replace("parakeet", "paschal");
  } else if (lookup.includes("reindeer")) {
    newLookup = lookup.replace("reindeer", "randazzo");
  } else if (lookup.includes("hawk")) {
    newLookup = lookup.replace("hawk", "hoffmann");
  } else if (lookup.includes("quail")) {
    newLookup = lookup.replace("quail", "qualityplumbing");
  } else if (lookup.includes("moose")) {
    newLookup = lookup.replace("moose", "mistersparky");
  }
  return newLookup;
}
